// extracted by mini-css-extract-plugin
export default {"wrapper":"SectionLogos_wrapper__erHG1","logo":"SectionLogos_logo__8+VI8"};